export default {
  baseURL: process.env.VUE_APP_API_BASEURL,
  timeout: process.env.VUE_APP_API_TIMEOUT_SECS * 1000,
  headers: {
    Accept: 'application/json'
  }
}
